import { get } from "../axiosConfig";
import { Price } from "../../../types";

export const PricesAPI = {
  async getPrices(): Promise<Price[]> {
    const { data } = await get("/telegram-fast-views/prices");
    return data;
  },

  async getCurrentPrice(): Promise<Price> {
    const { data } = await get("/telegram-fast-views/prices/current");
    return data;
  },
};
